import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconUserMinus = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--user-minus")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12,14 C14.7614237,14 17,16.2385763 17,19 L17,19 L17,21 C17,21.5522847 16.5522847,22 16,22 C15.4477153,22 15,21.5522847 15,21 L15,21 L15,19 C15,17.3431458 13.6568542,16 12,16 L12,16 L5,16 C3.34314575,16 2,17.3431458 2,19 L2,19 L2,21 C2,21.5522847 1.55228475,22 1,22 C0.44771525,22 0,21.5522847 0,21 L0,21 L0,19 C0,16.2385763 2.23857625,14 5,14 L5,14 Z M8.5,2 C11.2614237,2 13.5,4.23857625 13.5,7 C13.5,9.76142375 11.2614237,12 8.5,12 C5.73857625,12 3.5,9.76142375 3.5,7 C3.5,4.23857625 5.73857625,2 8.5,2 Z M23,10 C23.5522847,10 24,10.4477153 24,11 C24,11.5522847 23.5522847,12 23,12 L23,12 L17,12 C16.4477153,12 16,11.5522847 16,11 C16,10.4477153 16.4477153,10 17,10 L17,10 Z M8.5,4 C6.84314575,4 5.5,5.34314575 5.5,7 C5.5,8.65685425 6.84314575,10 8.5,10 C10.1568542,10 11.5,8.65685425 11.5,7 C11.5,5.34314575 10.1568542,4 8.5,4 Z" id="icon--centivo--user-minus"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1173.000000, -1312.000000)"/>
          <g id="Icon/user-minus">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--user-minus"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--user-minus"/>
          </g>
      </g>
  </IconWrapper>
)
